
import { ServiceState } from '../../rz-status_models';

export default function({state}:{state: ServiceState}) {  

  const icons = ["icon state_ok", "icon state_maintenance", "icon state_problem", "icon state_notok"]
  const labels = ["Service verfügbar", "service in Wartung", "Service eingeschränkt verfügbar", "Service nicht verfügbar"]

  return <span role="img" className={icons[state]} aria-label={labels[state]}></span>
}
